import { MDBCheckbox, MDBCol, MDBRow, MDBTextArea } from "mdb-react-ui-kit";
import React, {
    ChangeEvent,
    Dispatch,
    FC,
    SetStateAction,
    useEffect,
    useState,
} from "react";
import styles from "@/styles/home/Home.ModalNewsletter.module.scss";
import { EBtnType } from "@/models/common/enums";
import { useStore } from "@/store/index";
import { isValidEmail } from "@/utils/common";
import {
    INewsletterFormAnswer,
    INewsletterFormMetadata,
} from "@/models/newsletter";
import { convertDeltaToHtmlConverter } from "@/utils/common/delta";
import {
    subtitleModalNewsletter,
    titleModalNewsletter,
} from "@/utils/mockData/newsletterModalMock";
import { PhoneInput } from "react-international-phone";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import { useIsSM } from "@/utils/hooks/useWindowSizes";
import { IUTMParams } from "@/models/store/user";
import SectionTitle from "../common/SectionTitle";
import Input from "../common/Input";
import Btn from "../common/Btn";

type ValueProps = {
    email: string;
    fullName: string;
    age: string;
    phoneNumber: string;
    emailCheck: boolean;
    phoneNumberCheck: boolean;
    marketingPermissions: boolean;
    answers: INewsletterFormAnswer[];
};

const ModalNewsletter: FC<{
    metadata?: INewsletterFormMetadata;
    setShowModal: Dispatch<SetStateAction<boolean>>;
}> = ({ metadata, setShowModal }) => {
    const handleNewsletterCustom = useStore(
        state => state.handleNewsletterCustom
    );

    const [valueForm, setValueForm] = useState<ValueProps>({
        fullName: "",
        age: "",
        email: "",
        phoneNumber: "",
        emailCheck: false,
        phoneNumberCheck: false,
        marketingPermissions: false,
        answers: [],
    });

    const [privacyPolicy, setPrivacyPolicy] = useState(false);
    const [isPhoneValid, setIsPhoneValid] = useState(false);

    const countrySelectStyles = "2px solid #e6e8ec";

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setValueForm({ ...valueForm, [name]: value });
    };

    const onChangeAnswer = (indexField: number, value: string) => {
        // lo stesso indice del campo è utilizzato anche nella risposta
        const { answers } = valueForm;
        const answerToUpdate = answers.at(indexField);
        if (answerToUpdate) {
            answers[indexField] = {
                ...answerToUpdate,
                answer: value,
            };

            setValueForm((prevState: ValueProps) => ({
                ...prevState,
                answers,
            }));
        }
    };

    const getUTMParamsFromSession = (): IUTMParams => ({
        utmSource: sessionStorage.getItem("utm_source") || "",
        utmMedium: sessionStorage.getItem("utm_medium") || "",
        utmCampaign: sessionStorage.getItem("utm_campaign") || "",
        utmTerm: sessionStorage.getItem("utm_term") || "",
        utmContent: sessionStorage.getItem("utm_content") || "",
    });

    useEffect(() => {
        if (metadata) {
            setValueForm((prevState: ValueProps) => ({
                ...prevState,
                answers:
                    metadata?.fields?.map(field => ({
                        field: field?.field ?? "",
                        answer: "",
                    })) ?? [],
            }));
        }
    }, [metadata]);

    const deltaDefault = "{'ops':[]}";

    const isSM = useIsSM();

    const [marketingPermissions, setMarketingPermissions] = useState(false);

    return (
        <MDBRow>
            <MDBCol sm={12} md={5}>
                <div className={styles.leftPadding}>
                    <div
                        className={styles.background}
                        style={{
                            backgroundImage: `url(${metadata?.coverImage})`,
                        }}
                    />
                </div>
            </MDBCol>
            <MDBCol sm={12} md={7}>
                {metadata?.title && (
                    <SectionTitle
                        wordingsDelta={{
                            title: JSON.parse(metadata?.title ?? deltaDefault),
                            subtitle: JSON.parse(
                                metadata?.subtitle ?? deltaDefault
                            ),
                        }}
                        sectionTitle={{
                            classNameTitle: `text-center mt-3 ${styles.title}`,
                            classNameSubTitle: `text-center ${styles.subtitle}`,
                            ...{
                                title: titleModalNewsletter,
                                subTitle: subtitleModalNewsletter,
                            },
                        }}
                    />
                )}
                {/* <p style={{ textAlign: "right", fontSize: "13px" }}>
                    <span style={{ color: "#ed6f6f" }}>*</span> indicates
                    required
                </p> */}
                <MDBRow>
                    <MDBCol size={isSM ? 12 : 6}>
                        {" "}
                        <div className="mt-2">
                            <Input
                                name="fullName"
                                label={metadata?.fullNameLabel}
                                required
                                value={valueForm.fullName}
                                onChange={onChange as never}
                                type="text"
                            />
                        </div>
                    </MDBCol>
                    <MDBCol size={isSM ? 12 : 6}>
                        {" "}
                        <div className="mt-2">
                            <Input
                                name="age"
                                label={metadata?.ageLabel}
                                required
                                type="number"
                                value={valueForm.age}
                                onChange={onChange as never}
                                inputClassName={`${styles.customNumberInput}`}
                                /* eslint-disable  @typescript-eslint/no-explicit-any */
                                validationCb={(value: any) => value >= 18}
                            />
                        </div>
                    </MDBCol>
                </MDBRow>
                <MDBRow>
                    <MDBCol size={isSM ? 12 : 6}>
                        {" "}
                        <div className="mt-2">
                            <Input
                                name="email"
                                label={metadata?.emailLabel}
                                required
                                value={valueForm.email}
                                onChange={onChange}
                                type="text"
                            />
                        </div>
                    </MDBCol>
                    <MDBCol size={isSM ? 12 : 6}>
                        <div className="mt-2">
                            <p
                                style={{
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    color: "rgb(129, 126, 145)",
                                    marginBottom: "0.5rem",
                                    fontFamily: "GeneralSans-Regular",
                                }}
                            >
                                {`${metadata?.phoneNumberLabel} *`}
                            </p>
                            <div style={{ position: "relative" }}>
                                <PhoneInput
                                    value={valueForm.phoneNumber}
                                    onChange={phone => {
                                        setValueForm(
                                            (prevState: ValueProps) => ({
                                                ...prevState,
                                                phoneNumber: phone,
                                            })
                                        );
                                        setIsPhoneValid(
                                            isPossiblePhoneNumber(phone)
                                        ); // Aggiorna lo stato di validità
                                    }}
                                    style={{
                                        width: "100%",
                                        border: "unset",
                                        borderColor: isPhoneValid
                                            ? "#55ce97"
                                            : "#e6e8ec",
                                        borderRadius: "12px 12px 12px 12px",
                                    }}
                                    inputStyle={{
                                        height: "45px",
                                        borderRadius: "0px 12px 12px 0px",
                                        border: countrySelectStyles,
                                        borderColor: isPhoneValid
                                            ? "#55ce97"
                                            : "#e6e8ec",
                                        borderLeft: "none",
                                        outline: "none",
                                        width: "100%",
                                        color: "#777e90",
                                        fontFamily: "GeneralSans-Regular",
                                    }}
                                    countrySelectorStyleProps={{
                                        style: {
                                            height: "45px",
                                            borderRadius: "12px 0 0 12px",
                                            borderTop: countrySelectStyles,
                                            borderBottom: countrySelectStyles,
                                            borderLeft: countrySelectStyles,
                                            borderColor: isPhoneValid
                                                ? "#55ce97"
                                                : "#e6e8ec",
                                            outline: "none",
                                            padding: "2px",
                                        },
                                        buttonStyle: {
                                            border: "none",
                                        },
                                    }}
                                />
                                {isPhoneValid && (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        style={{
                                            position: "absolute",
                                            top: "12px",
                                            right: "10px",
                                            fill: "#55ce97",
                                        }}
                                    >
                                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                    </svg>
                                )}
                            </div>
                        </div>
                    </MDBCol>
                </MDBRow>
                <MDBRow>
                    {metadata?.fields?.map((field, index) => (
                        <MDBCol className="mt-2" size={isSM ? 12 : 6}>
                            <div>
                                <p className={styles.paragraphRadioButton}>
                                    {" "}
                                    {field?.field} {field?.isRequired && "*"}
                                </p>
                                <MDBTextArea
                                    value={
                                        valueForm.answers[index]?.answer ?? ""
                                    }
                                    required={field.isRequired}
                                    className={`PICustomTextArea ${styles.newsletterAnswer}`}
                                    rows={2}
                                    onChange={event =>
                                        onChangeAnswer(
                                            index,
                                            event.target.value
                                        )
                                    }
                                    maxLength={200}
                                    placeholder="Write here..."
                                />
                            </div>
                        </MDBCol>
                    ))}
                    {/* </MDBRow> */}
                    {metadata?.privacyConsentLabel && (
                        <div className={`mt-2 ${styles.privacySection}`}>
                            <MDBCheckbox
                                id="privacyPolicyTrue"
                                checked={privacyPolicy}
                                onClick={() => setPrivacyPolicy(prev => !prev)}
                                className={`${styles.formCheckLabel}`}
                            />
                            <p
                                className={`mb-1 ${styles.smallText}`}
                                dangerouslySetInnerHTML={{
                                    __html: convertDeltaToHtmlConverter(
                                        JSON.parse(
                                            metadata?.privacyConsentLabel ??
                                                deltaDefault
                                        )
                                    ),
                                }}
                            />
                        </div>
                    )}
                    <MDBRow>
                        <MDBRow>
                            {/* <p className={styles.bigText}>
                                Marketing Permissions
                            </p> */}
                        </MDBRow>
                        {metadata?.marketingPermissionsLabel && (
                            <MDBRow>
                                <div
                                    className={`mt-2 ${styles.privacySection}`}
                                >
                                    <MDBCheckbox
                                        id="marketingPermissionsTrue"
                                        checked={marketingPermissions}
                                        onClick={() =>
                                            setMarketingPermissions(
                                                prev => !prev
                                            )
                                        }
                                        className={`${styles.formCheckLabel}`}
                                    />
                                    <p
                                        className={styles.smallText}
                                        dangerouslySetInnerHTML={{
                                            __html: convertDeltaToHtmlConverter(
                                                JSON.parse(
                                                    metadata?.marketingPermissionsLabel ??
                                                        deltaDefault
                                                )
                                            ),
                                        }}
                                    />
                                </div>
                            </MDBRow>
                        )}
                        {/* <MDBRow>
                            <MDBCheckbox
                                label="Email"
                                className={`mx-3 ${styles.formCheckLabel}`}
                                name="emailCheck"
                                onChange={() => {
                                    setValueForm({
                                        ...valueForm,
                                        emailCheck: !valueForm.emailCheck,
                                    });
                                }}
                                value={
                                    valueForm.emailCheck as unknown as string
                                }
                                labelClass={styles.formCheckLabel}
                            />
                        </MDBRow>
                        <MDBRow>
                            <MDBCheckbox
                                label="Phone Number"
                                className="mx-3"
                                name="phoneNumberCheck"
                                onChange={() => {
                                    setValueForm({
                                        ...valueForm,
                                        phoneNumberCheck:
                                            !valueForm.phoneNumberCheck,
                                    });
                                }}
                                value={
                                    valueForm.phoneNumberCheck as unknown as string
                                }
                                labelClass={styles.formCheckLabel}
                            />
                        </MDBRow> */}
                        <MDBRow className="px-sm-5 mt-3 mx-2">
                            <Btn
                                btnType={EBtnType.PRIMARY}
                                onClick={() => {
                                    const utm = getUTMParamsFromSession();
                                    handleNewsletterCustom(
                                        valueForm.fullName,
                                        parseInt(valueForm.age, 10),
                                        valueForm.email,
                                        valueForm.phoneNumber,
                                        valueForm.emailCheck,
                                        valueForm.phoneNumberCheck,
                                        valueForm.marketingPermissions,
                                        valueForm.answers,
                                        utm
                                    );
                                    setValueForm({
                                        fullName: "",
                                        age: "",
                                        email: "",
                                        phoneNumber: "",
                                        answers:
                                            metadata?.fields?.map(field => ({
                                                field: field?.field ?? "",
                                                answer: "",
                                            })) ?? [],
                                        marketingPermissions:
                                            valueForm.marketingPermissions,
                                        emailCheck: valueForm.emailCheck,
                                        phoneNumberCheck:
                                            valueForm.phoneNumberCheck,
                                    });
                                    setPrivacyPolicy(false);
                                    setShowModal(false);
                                }}
                                disabled={
                                    !isValidEmail(valueForm.email.trim()) ||
                                    !privacyPolicy ||
                                    !isPhoneValid ||
                                    valueForm.fullName.length === 0 ||
                                    parseInt(valueForm.age, 10) < 18 ||
                                    valueForm.phoneNumber.length === 0 ||
                                    // (!valueForm.emailCheck &&
                                    //     !valueForm.phoneNumberCheck) ||
                                    // controlliamo se i campi required sono stati compilati
                                    !!metadata?.fields?.filter(
                                        (field, index) => {
                                            if (field.isRequired) {
                                                return !valueForm.answers.at(
                                                    index
                                                )?.answer.length;
                                            }
                                            return false;
                                        }
                                    ).length
                                }
                            >
                                Subscribe
                            </Btn>
                        </MDBRow>
                    </MDBRow>
                </MDBRow>
            </MDBCol>
        </MDBRow>
    );
};

export default ModalNewsletter;
